import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import bg from './img/bg.svg';
import { appStore } from '@store';
import { useT } from 'hooks';

interface Props {
	startTime?: number;
}

interface ContainerProps {
	isShowTimer?: boolean;
}

const Container = styled.div<ContainerProps>`
	align-items: center;
	background-image: ${({ isShowTimer }) =>
		isShowTimer ? 'linear-gradient(-330deg,#ff7612,#f0c 44.09%,#00baff 103.55%)' : `url(${bg})`};
	background-position: 50%;
	background-repeat: no-repeat;
	background-size: cover;
	color: #fff;
	display: flex;
	height: 62px;
	justify-content: space-between;
	left: 0;
	opacity: 0.9;
	overflow: hidden;
	position: fixed;
	right: 0;
	top: 0;
	transform: translateY(-62px);
	transition: transform 0.2s ease;
	width: 100%;
	z-index: 10;
	max-width: 430px;
	padding: 0 20px;
	margin: 0 auto;
`;

const Title = styled.p`
	font-size: 19px;
	font-weight: 500;
	letter-spacing: 0.41px;
	line-height: 19px;
`;

const Timer = styled.div`
	color: #fff;
	display: flex;
	font-size: 26px;
	font-weight: 600;
	position: relative;

	span {
		align-items: center;
		bottom: 6px;
		color: #fff;
		display: flex;
		font-size: 26px;
		font-weight: 600;
		justify-content: center;
		margin-top: 0;
		position: relative;
		width: 15px;
	}
`;

const Item = styled.div`
	display: flex;
	flex-direction: column;

	p:last-child {
		font-size: 7px;
		font-weight: 500;
		line-height: 8px;
		margin-top: 0;
		text-align: center;
		text-transform: uppercase;
		width: 100%;
	}
`;

export const Header: FC<Props> = props => {
	const { startTime } = props;
	const { paymentStore } = appStore;
	const [timeLeft, setTimeLeft] = useState(startTime || 540);
	const refHeader = useRef<HTMLDivElement>(null);
	const { T } = useT();

	useEffect(() => {
		const handleScroll = () => {
			if (rootElement) {
				const scrollPosition = rootElement.scrollTop;
				if (scrollPosition < 50) {
					if (refHeader.current) {
						refHeader.current.style.transform = 'translateY(-62px)';
					}
				} else if (scrollPosition > 100) {
					if (refHeader.current) {
						refHeader.current.style.transform = 'translateY(0)';
					}
				}
			}
		};

		const rootElement = document.querySelector('#root');
		if (rootElement) {
			rootElement.addEventListener('scroll', handleScroll);
		}

		return () => {
			if (rootElement) {
				rootElement.removeEventListener('scroll', handleScroll);
			}
		};
	}, []);

	useEffect(() => {
		const intervalId = setInterval(() => {
			setTimeLeft(prevTimeLeft => {
				if (prevTimeLeft <= 1) {
					clearInterval(intervalId);
					return 0;
				} else {
					return prevTimeLeft - 1;
				}
			});
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	useEffect(() => {
		if (paymentStore.isShowTimer) {
			setTimeLeft(1140);
		}
	}, [paymentStore.isShowTimer]);

	const formatTime = (time: number) => {
		const minutes = Math.floor(time / 60);
		const seconds = time % 60;
		return (
			<>
				<Item>
					<p>
						{minutes > 9 ? '' : '0'}
						{minutes}
					</p>
					<p>{T('timer_text_2')}</p>
				</Item>
				<span>:</span>
				<Item>
					<p>
						{seconds < 10 ? '0' : ''}
						{seconds}
					</p>
					<p>{T('timer_text_3')}</p>
				</Item>
			</>
		);
	};

	return (
		<Container ref={refHeader} isShowTimer={paymentStore.isShowTimer}>
			<Title>{T('timer_text_1')}</Title>
			<Timer>{formatTime(timeLeft)}</Timer>
		</Container>
	);
};
